module.exports = __webpack_public_path__ + "img/results_pull_maps.18a4a115.png";